// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import messagesData from './msgData';

const messages = messagesData as Record<string, Record<string, Function>>;

let currentLocale = (document.documentElement.getAttribute('lang') || 'fi').substring(0, 2).toLowerCase();

const message = (key: string, props?: Record<string, any>): string => {
    const localeMessages = messages[currentLocale] || messages['fi'];
    const msgFn = localeMessages[key];
    if (typeof msgFn === 'function') {
        return msgFn(props);
    }
    return key;
};

export const setLang = (lang: string): string => {
    currentLocale = lang;
    return currentLocale;
};

export default message;
